module.exports = __webpack_public_path__ + "img/arrow.89855a24.svg";